import{jsx as r}from"react/jsx-runtime";import{Skeleton as e,styled as i}from"@mui/joy";var o=i(e)`
  height: 24px;
  width: 100%;
  border-radius: 8px;
  margin: 16px 0;
  position: relative;
`,t=({isLoading:e,skeleton:i=r(o,{}),children:t})=>e?i:t;export{t as AsyncFilterLoader};
//# sourceMappingURL=AsyncFilterLoader.js.map